import React, { ReactNode } from "react";
import styles from "./PreviewLogo.module.scss";
import { LoadingContainer } from "~/containers/loading-сontainer";

interface PreviewLogoProps {
  /** Ссылка на картинку */
  src: string;
  /** Alt для картинки */
  alt?: string;
  /** Массив кнопок/действий справа */
  actions?: ReactNode[];
  /** Текст/описание под карточкой */
  description?: ReactNode;
  /** Дополнительный контент под картинкой (например UploadFile) */
  children?: ReactNode;
  isLoadingMount: boolean;
}

export const renderLogoPreview = (src?: string, alt?: string) => {
  if (!src) {
    return (
      <div style={{
        width: '100px',
        height: '100px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '2px dashed #d9d9d9',
        borderRadius: '50%',
        backgroundColor: '#f5f5f5'
      }}>
        <span style={{ color: '#bfbfbf', fontSize: '12px' }}>Нет логотипа</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={styles.previewImage}
    />
  );
};

export const PreviewLogo: React.FC<PreviewLogoProps> = ({
  src,
  alt,
  actions,
  description,
  children,
  isLoadingMount,
}) => {

  return (

    <div className={styles.previewCardWrapper}>
      <div className={styles.previewCard}>
        <div className={styles.previewContainer}>
          <LoadingContainer isLoading={isLoadingMount}>
            {renderLogoPreview(src, alt)}
          </LoadingContainer>
        </div>

        {actions && actions.length > 0 && (
          <div className={styles.actions}>
            {actions.map((action, i) => (
              <span key={i}>{action}</span>
            ))}
          </div>
        )}
      </div>

      {description && <p className={styles.description}>{description}</p>}

      {children}
    </div>
  );
};

